import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import SectionLink from "./SectionLink";


export default function ZylenHeader() {
    const [open, setOpen] = useState(false);
    const [stuck, setStuck] = useState(false);
    const [visible, setVisible] = useState(true);
    const lastY = useRef(0);
    useEffect(() => {
        const onScroll = () => {
            const y = window.scrollY; setStuck(y > 140);
            setVisible(prev => y < 140 ? true : y < lastY.current - 6 ? true : y > lastY.current + 6 ? false : prev); lastY.current = y;
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener('scroll', onScroll);
    }, []);


    const handleLoginPageOpen = () => {
        window.location.href = `${window.location.origin}/sign-in`;
    };

    return (<header className={`nav ${stuck ? "stuck" : ""} ${visible ? "up" : "down"}`}>
        <div className="wrap">
            <SectionLink
                className="logo"
                to="top"
                aria-label="zylen home"
            >
                <svg viewBox="231.93 247.08 378.03 101.10" fill="currentColor" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="zylen"><path d="M315.96,274.4c1.76,17.07-11.53,17.7-23.2,21.79-6.33,2.22-22.77,10.76-24.67,17.37-.87,3.01-.24,6.76,2.73,8.48,7.44,4.32,48.83-21.86,58.38-10.54,5.07,6.02,6.26,21.4-3.17,23-10.3,1.75-45.3-17.45-57.97-5.77-4.02,3.71-7.61,7.26-13.64,8.06-14.67,1.94-21.04-15.97-10.35-25.13,3.93-3.37,7.61-3.63,12-5.54,10.09-4.39,17.38-10.45,21.64-20.83,3.33-8.1,2.34-16.58,9.54-22.77,10.83-9.31,27.28-2.02,28.71,11.89Z"></path><path d="M270.92,272.93c0,6.86-16.34,14.59-24.4,14.59s-14.59-6.53-14.59-14.59,6.53-14.59,14.59-14.59,24.4,7.81,24.4,14.59Z"></path><path d="M351.83,309.26l25.26-23.06c1.49-1.36.57-3.92-1.41-3.92h-20.36c-3.31,0-5.93-2.9-5.74-6.35h0c.18-3.17,2.69-5.65,5.74-5.65h38.77c3.9,0,7.06,3.3,7.06,7.37h0c0,2.13-.88,4.16-2.42,5.56l-25.98,23.6c-1.49,1.36-.57,3.92,1.41,3.92h21.41c3.15,0,5.69,2.66,5.69,5.94h0c0,3.28-2.55,5.94-5.69,5.94h-38.93c-4.03,0-7.3-3.41-7.3-7.61h0c0-2.2.91-4.29,2.49-5.73Z"></path><path d="M421.22,292.73c0,12.94,3.39,18.06,12.33,18.06,8.1,0,12.8-4.2,12.8-19.58v-7.11c0-1.99.04-4.26.11-6.58.14-4.45,3.09-7.99,6.69-7.99h0c3.78,0,6.81,3.87,6.69,8.54-.08,2.85-.12,5.71-.12,8.12v27.73c0,23.42-7.81,34.26-28.15,34.26-6.72,0-12.57-1.32-17.63-4.25-2.92-1.69-3.96-6.2-2.27-9.59h0c1.53-3.09,4.73-4.05,7.3-2.34,3.4,2.27,7.5,3.83,12.04,3.83,10.54,0,15.35-5.83,15.35-19.81v-2.45c-3.01,5.71-8.29,9.21-16.95,9.21-15.53,0-21.56-9.09-21.56-29.02v-15.97c0-4.57,2.99-8.27,6.68-8.27h0c3.69,0,6.68,3.7,6.68,8.27v14.92Z"></path><path d="M524.02,313.3c6.25,0,10.78-1.6,14.08-5.01,1.8-1.86,4.55-2,6.58-.45h0c3.07,2.34,3.2,7.44.17,9.84-6.16,4.88-14.11,6.23-22.92,6.23-19.18,0-27.88-10.72-27.88-27.02s8.99-27.13,29.17-27.13c16.32,0,25.01,6.72,26.89,23.25.45,3.95-2.3,7.46-5.86,7.46h-33.08c-1.24,0-2.19,1.32-1.87,2.66,1.77,7.22,6.91,10.19,14.71,10.19ZM511.59,291.64h22.71c1.2,0,2.15-1.23,1.89-2.54-1.33-6.68-5.91-9.18-12.26-9.18-6.96,0-11.95,2.63-14.11,8.76-.5,1.42.42,2.96,1.78,2.96Z"></path><path d="M470,315.98v-60.64c0-4.56,3.19-8.26,7.12-8.26h0c3.93,0,7.12,3.7,7.12,8.26v60.64c0,4.56-3.19,8.26-7.12,8.26h0c-3.93,0-7.12-3.7-7.12-8.26Z"></path><path d="M609.96,296.57v20.14c0,4.15-2.85,7.52-6.33,7.52s-6.33-3.37-6.33-7.52v-21c0-8.26-5.38-13.81-13.39-13.81s-13.2,5.68-13.2,13.81v21.06c0,4.11-2.81,7.47-6.28,7.47-1.73,0-3.3-.84-4.44-2.2-1.14-1.35-1.84-3.22-1.84-5.27v-20.19c0-16.43,10.26-27.03,26.15-27.03s25.65,10.86,25.65,27.03Z"></path></svg>
            </SectionLink>
            <nav aria-label="main">
                <ul className="menu">
                    <li className="first">
                        <SectionLink to="job-board">job board</SectionLink>
                    </li>

                    <li>
                        <SectionLink to="features">features</SectionLink>
                    </li>

                    <li>
                        <SectionLink to="voices">voices</SectionLink>
                    </li>

                    <li>
                        <SectionLink to="events">events</SectionLink>
                    </li>

                    <li>
                        <SectionLink to="team">team</SectionLink>
                    </li>

                    <li>
                        <SectionLink to="contact">contact</SectionLink>
                    </li>
                </ul>
            </nav>
            <div className="nav-end">
                <button
                    type="button"
                    className="login"
                    onClick={handleLoginPageOpen}
                >
                    log in
                </button>
                <SectionLink className="getapp" to="get-the-app">
                    get the app
                </SectionLink>
                <button className="burger" id="burger" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="drawer" aria-label="open menu">
                    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M1 1h18M1 7h18M1 13h18"></path></svg>
                </button>
            </div>
        </div>
        <div className="drawer" id="drawer" hidden={!open}>
            <SectionLink to="job-board" onClick={() => setOpen(false)}>
                job board
            </SectionLink>

            <SectionLink to="features" onClick={() => setOpen(false)}>
                features
            </SectionLink>

            <SectionLink to="voices" onClick={() => setOpen(false)}>
                voices
            </SectionLink>

            <SectionLink to="events" onClick={() => setOpen(false)}>
                events
            </SectionLink>

            <SectionLink to="team" onClick={() => setOpen(false)}>
                team
            </SectionLink>

            <SectionLink to="contact" onClick={() => setOpen(false)}>
                contact
            </SectionLink>

            <button
                type="button"
                className="d-login"
                onClick={handleLoginPageOpen}
            >
                log in
            </button>
        </div>
    </header>);
}
